import { defineStore } from "pinia";
import type { $string } from "@/configs/types/Shared/typeShare";

const storeName = `useIncidentIncomingCallStore-${import.meta.env.VITE_APP_VERSION}`;

export const useIncidentIncomingCallStore = defineStore(storeName, {
  state: () => ({
    contactNumber: null as $string,
  }),
  actions: {
    onUpdateData(contactNumber: string) {
      this.contactNumber = contactNumber;
    },
  },
});
